import { redirect, RouteObject } from 'react-router-dom';

import i18n from 'app/i18n';
import { countries } from 'app/services';
import { ModuleLayout } from 'app/layouts';

import Form from './form';
import List from './list';

export const routes: RouteObject[] = [
  { path: 'countries', element: <ModuleLayout />,
    handle: { title: i18n.t('countries.title') },
    children: [
      { path: '', index: true, element: <List />,
        handle: { permission: 'countries:read', exclude: true },
      },
      { path: 'new', element: <Form />,
        handle: { title: i18n.t('countries.new'), permission: 'countries:create' },
      },
      { path: ':id', element: <Form />,
        loader: ({ params: { id } }) => countries.get(id!).then(({ data }) => data ?? redirect('..')),
        handle: { title: (country: any) => (country && i18n.t('countries.edit', country)), permission: 'countries:update' },
      },
    ],
  },
];
